import { Injectable } from '@angular/core';
import { GroupEntity } from '@pwc-bei/common';
import { environment } from 'src/environments/environment';
import {
  HttpUtils,
  PageableModel,
  PageableResponse,
  PageableService,
} from '@pwc-bei/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupEntityService extends PageableService<
GroupEntity,
GroupEntity
> {
  protected baseUrl: string = environment.authUrl;
  protected endpoint: string = 'group_entity';

  findByUserId(userId: number, societyId: number): Observable<GroupEntity[]> {
    return this.get(`byUserId/${userId}`);
  }

  convertResourceToModel(resource: GroupEntity): GroupEntity {
    return resource;
  }
  convertModelToResource(model: GroupEntity): GroupEntity {
    return model;
  }
}
